import { Link } from 'react-router-dom';

const tools = [
  {
    id: 'career',
    path: '/career-test',
    icon: 'ri-compass-3-line',
    number: '01',
    title: '계열·진로·전공·직업 탐색',
    description: '흥미, 가치관, 적성 검사를 통해 나에게 맞는 계열과 진로 방향을 탐색합니다.',
    features: ['Holland 흥미 검사', '직업 가치관 분석', '추천 전공·직업 연결'],
    color: 'primary',
    bg: 'bg-primary-50',
    border: 'border-primary-200',
    badge: 'bg-primary-500 text-white',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-600',
    btnClass: 'bg-primary-500 hover:bg-primary-600 text-white',
    image: 'https://readdy.ai/api/search-image?query=Korean%20student%20thinking%20about%20career%20options%20with%20compass%20and%20map%20on%20desk%2C%20warm%20light%2C%20educational%20setting%2C%20clean%20minimal%20background%2C%20sage%20green%20and%20cream%20tones&width=400&height=240&seq=tool-career-01&orientation=landscape'
  },
  {
    id: 'study',
    path: '/study-style',
    icon: 'ri-brain-line',
    number: '02',
    title: '성격·성향 기반 공부법 검사',
    description: '나의 학습 유형(VARK)과 성격 성향을 분석하여 과목별 최적 공부 전략을 제안합니다.',
    features: ['VARK 학습 유형 분석', '과목별 공부법 제안', '공부 환경·습관 가이드'],
    color: 'primary',
    bg: 'bg-primary-50',
    border: 'border-primary-200',
    badge: 'bg-primary-700 text-white',
    iconBg: 'bg-primary-100',
    iconColor: 'text-primary-700',
    btnClass: 'bg-primary-700 hover:bg-primary-800 text-white',
    image: 'https://readdy.ai/api/search-image?query=Student%20brain%20and%20learning%20style%20concept%20with%20colorful%20mind%20map%20and%20study%20tools%20on%20clean%20white%20desk%2C%20deep%20teal%20green%20and%20cream%20color%20palette%2C%20educational%20psychology%20concept&width=400&height=240&seq=tool-study-04&orientation=landscape'
  },
  {
    id: 'iq',
    path: '/iq-test',
    icon: 'ri-psychotherapy-line',
    number: '03',
    title: '종합 인지능력(IQ) 검사',
    description: '도형·패턴, 숫자·수리, 논리·추론, 공간·언어 4개 영역 100문항으로 종합적인 인지능력을 추정합니다.',
    features: ['100문항 종합 검사', '4개 영역 균형 평가', '웩슬러 기준 IQ 환산'],
    color: 'accent',
    bg: 'bg-accent-50',
    border: 'border-accent-200',
    badge: 'bg-accent-500 text-white',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    btnClass: 'bg-accent-500 hover:bg-accent-600 text-white',
    image: 'https://readdy.ai/api/search-image?query=IQ%20test%20concept%20with%20geometric%20puzzle%20shapes%2C%20number%20sequences%20and%20logic%20maze%20on%20clean%20desk%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20abstract%20brain%20and%20pattern%20symbols%2C%20educational%20flat%20illustration&width=400&height=240&seq=tool-iq-05&orientation=landscape'
  },
  {
    id: 'literacy',
    path: '/literacy-test',
    icon: 'ri-book-read-line',
    number: '04',
    title: '어휘력·문해력 검사',
    description: '일상·시사·경제·과학·예술·정치·문화 어휘와 다양한 지문을 읽고 내용을 파악하는 문해력을 평가합니다.',
    features: ['어휘력 140문항', '문해력 24문항', '유형별 상세 분석'],
    color: 'secondary',
    bg: 'bg-secondary-50',
    border: 'border-secondary-200',
    badge: 'bg-secondary-500 text-white',
    iconBg: 'bg-secondary-100',
    iconColor: 'text-secondary-600',
    btnClass: 'bg-secondary-500 hover:bg-secondary-600 text-white',
    image: 'https://readdy.ai/api/search-image?query=Korean%20vocabulary%20and%20reading%20comprehension%20concept%20with%20open%20books%20dictionary%20and%20text%20on%20a%20clean%20desk%2C%20warm%20sage%20green%20and%20cream%20tones%2C%20soft%20natural%20light%2C%20educational%20flat%20illustration%2C%20cozy%20studious%20atmosphere&width=400&height=240&seq=tool-literacy-06&orientation=landscape'
  },
  {
    id: 'english',
    path: '/english-test',
    icon: 'ri-book-open-line',
    number: '05',
    title: '영어 단어 검사',
    description: '초등·중등·고등 3단계 난이도로 뜻·유의어·반의어·빈칸 등 5가지 유형 230문항으로 영어 어휘력을 정밀 진단합니다.',
    features: ['초·중·고 단계별', '5가지 유형 230문항', '상위·하위 백분위'],
    color: 'accent',
    bg: 'bg-accent-50',
    border: 'border-accent-200',
    badge: 'bg-accent-500 text-white',
    iconBg: 'bg-accent-100',
    iconColor: 'text-accent-600',
    btnClass: 'bg-accent-500 hover:bg-accent-600 text-white',
    image: 'https://readdy.ai/api/search-image?query=English%20vocabulary%20learning%20concept%20with%20alphabet%20letters%20flashcards%20and%20open%20dictionary%20on%20a%20clean%20bright%20desk%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20soft%20natural%20light%2C%20educational%20flat%20illustration%2C%20modern%20studious%20atmosphere&width=400&height=240&seq=tool-english-07&orientation=landscape'
  }
];

export default function ToolCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="inline-block text-primary-600 text-sm font-semibold tracking-widest uppercase mb-3">종합 진단 도구</span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            6가지 진로탐구 도구로 공부 데이터를 종합 분석합니다
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            다섯 가지 검사와 선택과목 추천을 하나로 분석해 맞춤 가이드를 제공합니다
          </p>
        </div>

        {/* Tool Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {tools.map((tool) => (
            <Link
              key={tool.id}
              to={tool.path}
              className={`rounded-xl border ${tool.border} ${tool.bg} overflow-hidden group block hover:shadow-md transition-shadow`}
            >
              {/* Image */}
              <div className="relative h-44 overflow-hidden">
                <img
                  src={tool.image}
                  alt={tool.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                <div className={`absolute top-3 left-3 ${tool.badge} text-xs font-bold px-2.5 py-1 rounded-full`}>
                  {tool.number}
                </div>
              </div>

              {/* Content */}
              <div className="p-5">
                <div className="flex items-start gap-3 mb-3">
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${tool.iconBg}`}>
                    <i className={`${tool.icon} text-lg ${tool.iconColor}`}></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-foreground-950 text-base leading-tight">{tool.title}</h3>
                  </div>
                </div>

                <p className="text-foreground-600 text-sm mb-4 leading-relaxed">{tool.description}</p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-4">
                  {tool.features.map((feature) => (
                    <span key={feature} className="text-xs bg-background-100 text-foreground-700 px-2.5 py-1 rounded-full">
                      {feature}
                    </span>
                  ))}
                </div>

                <span
                  className={`whitespace-nowrap block text-center w-full py-2.5 rounded-lg text-sm font-semibold ${tool.btnClass} transition-colors cursor-pointer`}
                >
                  시작하기 <i className="ri-arrow-right-line ml-1"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}